import { Stack } from '@mui/material';
import { useEntityActions, useEntityChildren } from 'api/entity';
import { useWorkspaceId } from 'api/providers/workspaceProvider';
import { Chat } from 'components/Chat';
import React, { useMemo } from 'react';
import { FinsightEntity, ScratchpadMessage } from 'shared';
import { useSWRConfig } from 'swr';

export function EntityDiscussion(props: { entity: FinsightEntity }) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { entity } = props;
  const { createEntity, deleteEntity } = useEntityActions();
  const workspaceId = useWorkspaceId();
  const { cache, mutate } = useSWRConfig();
  const children = useEntityChildren(entity.id);

  const discussionItems = useMemo<ScratchpadMessage[]>(() => {
    return (
      children.data
        ?.filter((x) => x.types[0] === 'discussion')
        .map((x) => ({
          channel_id: '',
          content: x.description || '',
          created: new Date(x.created),
          id: x.id,
          user_id: '',
        }))
        .sort((a, b) => b.created.getTime() - a.created.getTime()) ?? []
    );
  }, [children.data]);

  return (
    <Stack
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        minHeight: 400,
      }}
    >
      <Chat
        messages={discussionItems}
        onNewMessage={async (message) => {
          await createEntity({
            type: 'discussion',
            parent: entity.id,
            name: message.slice(0, 20),
            description: message,
          });
          Array.from(cache.keys())
            .filter((x) =>
              x.includes(
                `/workspace/${workspaceId}/entity/${entity.id}/children`,
              ),
            )
            .forEach((key) => mutate(key));
        }}
        onDelete={async (message) => {
          await deleteEntity(message.id);
          Array.from(cache.keys())
            .filter((x) =>
              x.includes(
                `/workspace/${workspaceId}/entity/${entity.id}/children`,
              ),
            )
            .forEach((key) => mutate(key));
        }}
      />
    </Stack>
  );
}
